import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./FileUploadModal.css";
import taxoApi from "../../api/taxoApi";

const FileUploadModal = ({ show, handleClose, onSuccess }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    if (event.target.files[0] && !event.target.files[0].name.endsWith(".csv")) {
      setErrorMsg("Solo se permiten ficheros CSV.");
    } else {
      setErrorMsg("");
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = function (e) {
        try {
          const contentCode = e.target.result.split("base64,")[1];
          taxoApi.postCSV("provincias", contentCode)
            .then((response) => {
              if (onSuccess) onSuccess();
            })
            .catch((error) => {
              console.error("Error uploading file:", error);
                setErrorMsg("Error al subir el fichero. Por favor, inténtelo de nuevo.");
            });
        } catch (error) {
          console.error("Error processing file:", error);
            setErrorMsg("Error al procesar el fichero. Por favor, asegúrese de que es un CSV válido.");
        }
      }
      reader.onerror = function () {
        console.error("Error reading file");
        setErrorMsg("Error al leer el fichero. Por favor, inténtelo de nuevo.");
      };
      reader.readAsDataURL(selectedFile);
    } else {
      setErrorMsg("Por favor, seleccione un fichero.");
    }
  };

  return (
    <Modal show={show} onHide={handleClose} scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Subir Fichero de dimensiones</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formFile">
            <Form.Label>Seleccione el fichero</Form.Label>
            <Form.Control type="file" onChange={handleFileChange} />
            {errorMsg && <div className="text-danger">{errorMsg}</div>}
          </Form.Group>
          <Button variant="primary" type="submit">
            Submit
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default FileUploadModal;
